<template>
	<div class="main_display" v-if="!ExhibitDetail.uuid">
		<template v-if="isPc">
			<img class="display-title" v-if="En" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/title-home-shows-en.png" alt="">
			<img class="display-title" v-else src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/title-home-shows.png" alt="">
		</template>
		<div class="display-title" :style="{ height: En ? '2.2rem' : '1.44rem' }" v-else>
			<img v-if="En" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/wap/title-home-shows-en.png" alt="">
			<img v-else src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/wap/title-home-shows.png" alt="">
		</div>
		<div class="main_display1">
			<scrollText black></scrollText>
		</div>
		<div class="main_display2"></div>
		<div class="m">
			<div class="swiper mySwipers">
				<img src="../../../assets/images/prev1.png" @click="prev" class="btn prev" />
				<img src="../../../assets/images/next1.png" @click="next" class="btn next" />
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(v, index) in list" :key="v.uuid">
						<div class="label">
							<div @click.stop="itemFn(v)">
								<div class="pic"><img :src="v.underlayUrl + '?x-image-process=image/resize,w_1200,limit_0'" /></div>
								<span v-if="!En" v-html="visitorTitles[index]"></span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import protal from "@/api/protal";
import router from "../../../router";
import { mapState } from "vuex";
export default {
    name: "display",
    data() {
        return {
            list: [],
			visitorTitles: ['数控机床与<br>金属加工展', '工业自动化展','绿色低碳展','新一代信息<br>技术与应用展','智慧能源展','交通运输<br>装备展','机器人展','科技创新展','新材料产业展']
        };
    },
	computed: {
		...mapState({
			ExhibitDetail: state => state.ExhibitDetail
		})
	},
    created() {
        this.getWebHomeExhibit();
    },
    methods: {
		itemFn(v) {
			this.$router.push({path:'/zhanlan',query:{uuid:v.uuid}})
			const headList = this.$store.state.headList
			const headIndex = this.$store.state.headIndex
			this.$jsAPI('track', 'ciif_gbzyExhibitionListClick', {
				contentID_var: v.uuid,
				contentName_var: v.name,
				firstNavigationName_var: headList[headIndex].name,
				secondNavigationName_var: headList[headIndex].children && headList[headIndex].children.length ? localStorage.getItem('leftIndex') : ''
			})
		},
        // 官网查询专业展知名展商
        getWebHomeExhibit() {
            protal.getWebHomeExhibit().then(r => {
                this.list = r.data;
                if (this.isPc) {
                    this.$nextTick(function () {
                        this.swiper = new Swiper(".mySwipers", {
                            slidesPerView: "auto",
                            loop: true,
                            speed: 600, // 滑动速度
                        });
                    });
                }
            });
        },
        prev() {
            this.swiper.slidePrev();
        },
        next() {
            this.swiper.slideNext();
        }
    },
    components: { router }
}
</script>

<style lang="less" scoped="scoped">
@media screen and (min-width: 769px) {
	.btn {
		display: none;
		width: .48rem;
		position: absolute;
		top: 50%;
		z-index: 999;
		transform: translateY(-50%);

		&:hover {
			opacity: 0.8;
		}

		&.prev {
			left: .28rem;
		}

		&.next {
			right: .28rem;
		}
	}

	.main_display {
		overflow: hidden;
		width: 100%;
		padding: 0 0 .8rem 0;
		position: relative;

		.display-title {
			width: auto;
			height: 144px;
		}

		.main_display1 {
			position: absolute;
			right: 140px;
			top: 83px;
		}

		.main_display2 {
			width: 1640px;
			height: 1px;
			border: 1px solid #0B243F;
			opacity: 0.2;
			margin: -12px auto 0;
		}

		.m {
			width: 1640px;
			margin: 0 auto;

			em {
				display: flex;
				text-align: center;
				
				align-items: center;
				justify-content: center;
				
				margin-top: .4rem;
				i{
					color: #FFFFFF;
				font-size: .2rem;
				font-family: syn;
				margin: 0 .16rem;
				}
			}

			.mySwipers {
				width: 100%;
				overflow: hidden;
				margin-top: .18rem;

				.swiper-slide {
					width: 164px;
					background: #F0F0F0;
					margin-top: .3rem;
					margin-right: 20px;

					.label {
						width: 100%;
						cursor: pointer;

						.pic {
							overflow: hidden;
							width: 100%;
							height: 164px;

							img {
								width: 100%;
								height: 100%;
								object-fit: cover;
								display: block;
								border-radius: 12px;
							}
						}

						&:hover {
							span {
								color: #FC581C;
								transform: translateY(-20px);
							}

							.pic {
								transform: translateY(-20px);
							}
						}

						span {
							display: flex;
							align-items: center;
							justify-content: center;
							font-size: .24rem;
							line-height: 36px;
							text-align: center;
							padding: 0 .1rem;
							transition: all .1s;
							box-sizing: border-box;
							font-family: sy;
							color: #000;
							margin-top: 12px;
							background-color: transparent !important;
						}
					}
				}
			}

			.head {
				display: flex;
				align-items: center;
				justify-content: center;

				div {
					width: .86rem;
					height: .02rem;
					background: #fff;
				}

				span {
					font-size: .4rem;
					margin: 0 .28rem;
					color: #fff;
					line-height: 1;
					font-family: syb;
				}
			}
		}
	}
}

@media screen and (max-width: 768px) {
	.btn {
		display: none;
		width: .48rem;
		position: absolute;
		top: 50%;
		z-index: 999;
		transform: translateY(-50%);

		&:hover {
			opacity: 0.8;
		}

		&.prev {
			left: .28rem;
		}

		&.next {
			right: .28rem;
		}
	}

	.main_display {
		background-color: #F4F4F6;
		padding-bottom: 1rem;
		position: relative;

		.display-title {
			width: 100%;
			height: auto;
			height: 1.44rem;
			margin-bottom: .2rem;

			img {
				width: 100%;
				height: auto;
			}
		}

		.main_display1 {
			display: none;
		}

		.main_display2 {
			width: 6.78rem;
			height: 1px;
			opacity: 0.2;
			margin: 0 auto;
		}

		.m {
			width: 6.78rem;
			margin: 0 auto;

			em {
				display: flex;
				text-align: center;
				
				align-items: center;
				justify-content: center;
				
				margin-top: .4rem;
				i{
					color: #FFFFFF;
				font-size: .2rem;
				font-family: syn;
				margin: 0 .16rem;
				}
			}

			.mySwipers {
				width: 7.14rem;

				.swiper-wrapper {
					display: flex;
					flex-wrap: wrap;
				}

				.swiper-slide {
					width: 2.12rem;
					margin-right: .2rem;
					margin-bottom: .2rem;
					border-radius: .28rem;

					.label {
						width: 100%;
						cursor: pointer;

						.pic {
							overflow: hidden;
							width: 100%;
							height: 2.12rem;

							img {
								width: 100%;
								height: 100%;
								object-fit: cover;
								display: block;
								border-radius: .28rem;
							}
						}

						span {
							display: flex;
							align-items: center;
							justify-content: center;
							font-size: .24rem;
							line-height: .36rem;
							text-align: center;
							padding: 0 .1rem;
							transition: all .1s;
							box-sizing: border-box;
							font-family: sy;
							color: #000;
							margin-top: .12rem;
						}
					}
				}
			}

			.head {
				display: flex;
				align-items: center;
				justify-content: center;

				div {
					width: .86rem;
					height: .02rem;
					background: #fff;
				}

				span {
					font-size: .4rem;
					margin: 0 .28rem;
					color: #fff;
					line-height: 1;
					font-family: syb;
				}
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/home/components/display.vue